import {
  BadgeCheck,
  Building2,
  ClipboardList,
  FileSignature,
  FileText,
  FolderOpen,
  Inbox,
  LayoutDashboard,
  Settings,
  UserPlus,
  type LucideIcon,
} from 'lucide-react'

export interface NavLink {
  title: string
  to: string
  icon: LucideIcon
  /** One line shown on the placeholder page until the module ships. */
  summary: string
}

export interface NavSection {
  label?: string
  items: NavLink[]
}

export const NAV: NavSection[] = [
  {
    items: [{ title: 'Home', to: '/', icon: LayoutDashboard, summary: 'Your day at a glance.' }],
  },
  {
    label: 'Sales',
    items: [
      {
        title: 'Enquiries',
        to: '/enquiries',
        icon: Inbox,
        summary:
          'New leads from the website, email and phone, checked for duplicates before anyone re-types them.',
      },
      {
        title: 'Site surveys',
        to: '/surveys',
        icon: ClipboardList,
        summary:
          'Walk the site on a phone or tablet: areas, frequencies, timings and photos. Works with a weak signal.',
      },
      {
        title: 'Quotes',
        to: '/quotes',
        icon: FileText,
        summary:
          'Build a quote from the price book, see the margin as you go, and send a proposal clients can accept on their phone.',
      },
      {
        title: 'Contracts',
        to: '/contracts',
        icon: FileSignature,
        summary:
          'Signed client agreements with the evidence, start and review dates, notice and value.',
      },
      {
        title: 'To check',
        to: '/approvals',
        icon: BadgeCheck,
        summary:
          "Everything waiting on a person: Kira's drafts, proposals about to run out, failed emails.",
      },
    ],
  },
  {
    label: 'Records',
    items: [
      {
        title: 'Customers',
        to: '/customers',
        icon: Building2,
        summary:
          'Companies, contacts and service sites kept separate, so one customer can have many sites.',
      },
      {
        title: 'Library',
        to: '/library',
        icon: FolderOpen,
        summary:
          'Terms and conditions, insurance certificates, method statements and policies, with expiry reminders.',
      },
    ],
  },
  {
    label: 'People',
    items: [
      {
        title: 'Onboarding',
        to: '/onboarding',
        icon: UserPlus,
        summary:
          'Send a new starter one secure link for their contract, forms, policies and documents, then track what is left.',
      },
    ],
  },
  {
    label: 'Admin',
    items: [
      {
        title: 'Settings',
        to: '/settings',
        icon: Settings,
        summary: 'Branding, VAT, price books, users and roles, and connections for Hermes.',
      },
    ],
  },
]

export const ALL_LINKS = NAV.flatMap((s) => s.items)
